import React, {useCallback, useContext} from 'react';
import {PageLayoutHorizontalRows} from 'layout/components';
import {
  EditLearningPathDetails,
  EditLearningPathDetailsForm,
  EditLearningPathFooter,
  EditLearningPathHeader,
  KnowledgeSkillAndAbilitiesDetails,
} from '..';
import {FormContext} from 'forms/formik/FormContextProvider';
import {LearningPathSessions} from 'admin/resources/learning-paths/components';

export const LearningPathViewEditContainer = ({loading}) => {
  const {formikFormRef, isDirty, setIsDirty, submitFormikForm} = useContext(FormContext);

  const submitFormClickHandler = useCallback(() => formikFormRef?.current && submitFormikForm(), [
    formikFormRef,
    submitFormikForm,
  ]);

  return (
    <PageLayoutHorizontalRows
      headerSize="large"
      loading={loading}
      header={<EditLearningPathHeader />}
      contentUp={
        <EditLearningPathDetailsForm formikFormRef={formikFormRef} setIsDirtyCallback={setIsDirty}>
          <EditLearningPathDetails isDirty={isDirty} setIsDirtyCallback={setIsDirty} />
        </EditLearningPathDetailsForm>
      }
      contentDown={<LearningPathSessions />}
      contentMiddle={<KnowledgeSkillAndAbilitiesDetails />}
      footer={<EditLearningPathFooter isDirty={isDirty} submitFormCallback={submitFormClickHandler} />}
    />
  );
};
